<template>
  <div>
    <Toolbar :title="t('Cells')"></Toolbar>

    <div class="ma-3">
      <h3 class="accent--text"> {{ t('Welcome') }} </h3>
      <div class="mt-3"> {{ t('Intro') }} </div>
    </div>

  </div>
</template>

<script>
import Toolbar from '@/components/layout/Toolbar'
export default {
  components: { Toolbar }
}
</script>
